import { render, staticRenderFns } from "./LandingFeaturesCover.vue?vue&type=template&id=0f22bde0"
import script from "./LandingFeaturesCover.vue?vue&type=script&lang=js"
export * from "./LandingFeaturesCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports